<template>
  <transition name="sf-fade">
    <div
      v-if="isVisible && !levelsLoading"
      class="fixed inset-x-0 bottom-0 z-50 lg:p-4 lg:max-w-4xl lg:mx-auto"
      data-testid="partners-transition-banner"
    >
      <div class="lg:hidden flex flex-col gap-2 p-5 bg-EXPONDO-black text-EXPONDO-grey-20">
        <p class="font-bold text-EXPONDO-white">
          {{ $t('partners-transition-title') }}
        </p>
        <p>{{ subtitle }}</p>
        <button
          type="button"
          class="self-center mt-3 py-2 px-6 text-sm underline"
          data-testid="partners-transition-banner-dismiss"
          @click="dismiss"
        >
          {{ $t('partners-transition-dismiss') }}
        </button>
      </div>
      <div class="hidden lg:block">
        <NotificationBanner
          :status="NOTIFICATION_STATUS.info"
          :title="$t('partners-transition-title')"
          :subtitle="subtitle"
          font-size-class="text-sm"
          @close="dismiss"
        />
      </div>
    </div>
  </transition>
</template>

<script lang="ts">

import NotificationBanner from '~/components/atoms/Notification/NotificationBanner.vue';
import { formatNumberAsCurrency } from '~~/helpers/formatNumberAsCurrency';
import { NOTIFICATION_STATUS } from '~~/types/components/Notification/NotificationStatus';

export default defineComponent({
  name: 'PartnersTransitionBanner',
  components: {
    NotificationBanner,
  },
  setup() {

    const i18n = useI18n();
    const { isVisible, syncWithLocalStorage, dismiss } = usePartnersTransitionBanner();
    const { ratio, currency, loading: levelsLoading, load: loadLevels } = useCDPLoyaltyLevels();

    const ratioSentence = computed(() => (ratio.value && currency.value
      ? i18n.t('partners-transition-ratio', {
        amount: formatNumberAsCurrency(ratio.value, { i18n, currencyCode: currency.value }),
      })
      : ''));

    const subtitle = computed(() => [
      i18n.t('partners-transition-unchanged'),
      ratioSentence.value,
      i18n.t('partners-transition-progress'),
    ].filter(Boolean).join(' '));

    // the banner waits for the ratio, so its text does not change after it has appeared
    watch(isVisible, (visible) => {

      if (visible) {

        loadLevels();

      }

    }, { immediate: true });

    onMounted(syncWithLocalStorage);

    return {
      NOTIFICATION_STATUS,
      isVisible,
      levelsLoading,
      subtitle,
      dismiss,
    };

  },
});

</script>
